goog.provide("shadow.js.shim.module$src$svg$wpp$files$folder_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$files$folder_svg");
shadow.js.shim.module$src$svg$wpp$files$folder_svg = shadow.js.nativeProvides["src/svg/wpp/files/folder.svg"] = shadow$bridge("src/svg/wpp/files/folder.svg");
module$shadow_js_shim_module$src$svg$wpp$files$folder_svg.default = shadow.js.shim.module$src$svg$wpp$files$folder_svg;
